/**
 * Captures and processes all referral and UTM parameters from URL search params
 * @returns {Object|null} Referral data object or null if no tracking params found
 */
export const handleReferralParams = () => {
  // Get URL search params
  const searchParams = new URLSearchParams(window.location.search);
  
  // Get all possible tracking parameters
  const trackingParams = {
    // Affiliate/partner tracking
    source: searchParams.get('source'),
    partner: searchParams.get('partner'),
    affiliate: searchParams.get('affiliate'),
    
    // UTM parameters
    utm_source: searchParams.get('utm_source'),
    utm_medium: searchParams.get('utm_medium'),
    utm_campaign: searchParams.get('utm_campaign'),
    utm_term: searchParams.get('utm_term'),
    utm_content: searchParams.get('utm_content'),
    
    // Generic referral
    ref: searchParams.get('ref'),
    
    // Additional tracking
    channel: searchParams.get('channel'),
    gclid: searchParams.get('gclid'),
    fbclid: searchParams.get('fbclid'),
  };
  
  // Filter out undefined/null values
  const filteredParams = Object.fromEntries(
    Object.entries(trackingParams).filter(([_, value]) => value != null)
  );
  
  // Only return referral data if at least one tracking parameter exists
  if (Object.keys(filteredParams).length > 0) {
    return {
      ...filteredParams,
      timestamp: new Date().toISOString(),
      status: 'registered',
      landingPath: window.location.pathname
    };
  }
  
  return null;
};

/**
 * Constructs URL with affiliate parameters
 * @param {string} partner - Partner code
 * @param {string} baseUrl - Full URL or path (default: '/getstarted')
 * @param {boolean} useAppDomain - Whether to prepend app domain (default: true)
 * @returns {string} Full URL with affiliate parameters
 */
export const constructAffiliateUrl = (partner, baseUrl = '/getstarted', useAppDomain = true) => {
  const params = new URLSearchParams({
    source: 'affiliate',
    partner: partner
  });
  
  // Handle absolute vs. relative URLs
  let finalUrl = baseUrl;
  if (useAppDomain && !baseUrl.includes('://')) {
    // If it's a relative path and useAppDomain is true, prepend app domain
    finalUrl = `https://app.npcollaborator.com${baseUrl.startsWith('/') ? '' : '/'}${baseUrl}`;
  }
  
  // Add parameters
  if (finalUrl.includes('?')) {
    // URL already has parameters, append with &
    return `${finalUrl}&${params.toString()}`;
  } else {
    // URL has no parameters, start with ?
    return `${finalUrl}?${params.toString()}`;
  }
}; 